export const SOMEONE_ELSE_REPORT = 'You can not see someone else report';
export const LOGIN_NEEDED = 'You have to be logged-in to perform this operation';
